import React from 'react'
import {
  Typography,
  SpacerVertical
} from '@klarna/bubble-ui'

import content from '../../content'
import { interpolateContent } from '../../utils'

interface LearnMoreTimelineProps {
  copy: {
    [key: string]: string
  }
}

function LearnMoreTimeline({ copy }: LearnMoreTimelineProps) {
  if (!copy) return null

  return (
    <div className="timeline">
      <SpacerVertical spaceToken='space/100'/>

      {Object.keys(copy).map((index: string) => {
        const matches = (/{{c:([\s\S]+?)}}/g).exec(copy[index])

        return (
          <ul key={`timeline-${index}`} className={matches ? 'with-badge' : ''}>
            <div className={matches ? 'line-with-badge' : ''}>
              <Typography textToken='text-style/text/paragraphs/body/regular'>{interpolateContent(copy[index], content)}</Typography>
            </div>
          </ul>
        )
      })}
    </div>
  )
}

export default LearnMoreTimeline
